import { inject, Pipe, PipeTransform } from '@angular/core';
import { USER } from '@marmon/frontend/common';
import { accessTag, AlgoliaAnalysis } from '@marmon/shared/types/analysis';

@Pipe({
	standalone: true,
	name: 'isSharedAnalysis',
})
export class IsSharedAnalysisPipe implements PipeTransform {
	private readonly user = inject(USER);

	transform(analysis: AlgoliaAnalysis) {
		const user = this.user.value;
		if (!user) return false;

		// if the analysis is owned by the user, it is not shared
		if (analysis.createdById === user.id) return false;

		// handle cases where _tags might be undefined or null
		if (!analysis._tags) return false;

		return analysis._tags.includes(accessTag(user.id));
	}
}
